var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMvWgEmptyVidIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "48px",
    viewBox: "0 0 64 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hi-Fi-WG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Gallery-Empty-State",
    transform: "translate(-740.000000, -281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vid",
    transform: "translate(740.000000, 281.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 1,
    y: 1,
    width: 62,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.19141,13.00027 L27.19179,13 C27.73079,13 28.29331,13.13672 28.77769,13.39453 L42.05869,21.02733 C43.01965,21.55853 43.66809,22.62493 43.66809,23.80463 C43.66809,24.81243 43.10167,25.65619 42.36729,26.24603 C42.36729,26.27338 42.33604,26.30072 42.30869,26.30072 C42.25009,26.414 42.16806,26.52728 42.05478,26.58197 L42.02744,26.58197 L28.77344,34.21477 C28.7461,34.21477 28.7461,34.21477 28.7461,34.24211 C27.7852,34.74602 26.59768,34.74602 25.6094,34.18352 C24.56641,33.59372 24.02734,32.52732 24,31.43352 L24,16.19952 L24,16.17218 C24,15.21898 24.51168,14.37527 25.2734,13.75808 C25.30074,13.73073 25.30074,13.70339 25.32808,13.70339 C25.38277,13.59011 25.49605,13.47683 25.60933,13.42214 C25.72261,13.36355 25.86324,13.36355 25.97652,13.30886 C25.97652,13.30886 26.00387,13.3362 26.03121,13.30886 C26.40235,13.16824 26.79688,13.00027 27.19141,13.00027 Z M27.21875,14.57057 L27.21863,14.57014 C26.96472,14.57014 26.71082,14.62483 26.48816,14.76936 L26.40222,14.76936 C25.8905,15.07786 25.60925,15.60916 25.60925,16.17166 L25.60925,31.43766 C25.60925,32.00016 25.89441,32.53141 26.40222,32.81266 C26.91002,33.12125 27.5038,33.09391 27.95692,32.84 L27.98426,32.84 L41.03526,25.3439 C41.08994,25.31656 41.12119,25.28922 41.17588,25.23062 C41.20713,25.23062 41.23447,25.20328 41.23447,25.20328 C41.74229,24.92208 42.08213,24.41817 42.08213,23.80098 C42.08213,23.21118 41.74228,22.67993 41.23447,22.39868 L27.98047,14.76588 C27.75391,14.65651 27.5,14.57057 27.21875,14.57057 Z",
    id: "Combined-Shape",
    fill: "#DBDBDB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvWgEmptyVidIcon);
export default __webpack_public_path__ + "static/media/mv-wg-empty-vid-icon.3a0b4b272a423a78bc6bc6906d62e8cc.svg";
export { ForwardRef as ReactComponent };